module.exports = __webpack_public_path__ + "static/media/description-img.ba8393f5.png";